import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../Global/Dropdowns/Dropdown';
import DropdownSection from '../Global/Dropdowns/DropdownSection';
import ContentIconType from '../Global/Icons/ContentIconType';
import VerticalTextLockup from '../Global/Typography/VerticalTextLockup';
import contentTypeName from '../../utils/contentTypeName';
import { createContentAccess } from '../../utils/accessLevelCheck';
import { buildLink } from '../../utils/buildLink';

const MyContentListItem = ({ content, onDelete, loggedInUser }) => {
  let contentLink = buildLink(content.type);
  contentLink = `${contentLink}/${content.id}`;

  const readableContentType = contentTypeName(content.type);
  let editLink;
  switch (content.type) {
    case 'session':
      editLink = 'my-sessions';
      break;
    default:
      editLink = `my-content/${readableContentType}/${content.id}`;
  }

  let canAccess;
  if (loggedInUser.computed_access) {
    canAccess = createContentAccess(loggedInUser.computed_access, loggedInUser.org_id);
  }

  return (
    <li className="content-list-new__list-item content-list-new__list-item--not-clickable">
      <div className="d-flex">
        <ContentIconType contentType={content.type} />
      </div>

      <VerticalTextLockup
        title={<a href={contentLink} className="like-p">{content.title}</a>}
        subtitle={<span className="like-small">Created by <span className="fw-medium">{content.author.full_name}</span></span>}
      />

      {canAccess === true &&
        <Dropdown size="s" position="right">
          <DropdownSection>
            <a href={editLink} className="dropdown-link">Edit {readableContentType}</a>
          </DropdownSection>
          <DropdownSection>
            <button className="faux-btn dropdown-link" onClick={() => onDelete(content.type, content.id)}>Delete {readableContentType}</button>
          </DropdownSection>
        </Dropdown>
      }
    </li>
  );
};

MyContentListItem.propTypes = {
  content: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
  loggedInUser: PropTypes.object.isRequired,
};

export default MyContentListItem;



// WEBPACK FOOTER //
// ./library/app/components/Create/MyContentListItem.js